export const BatchUpdateListingGetters = {
  BatchUpdateResult: 'BatchUpdateListingGetters.BatchUpdateResult',
  IsAllUpdateSuccess: 'BatchUpdateListingGetters.IsAllUpdateSuccess',
  BatchUpdateTolObject: 'BatchUpdateListingGetters.BatchUpdateTolObject',
  IsAllResultsSelected: 'BatchUpdateListingGetters.IsAllResultsSelected',
  SelectedBatchResults: 'BatchUpdateListingGetters.SelectedBatchResults',
  IsBatchPdfGenerated: 'BatchUpdateListingGetters.IsBatchPdfGenerated'
};

export const BatchUpdateListingActions = {
  RetrieveBatchUpdateResultList: 'BatchUpdateListingActions.RetrieveBatchUpdateResultList',
  ToggleSelectBatchResult: 'BatchUpdateListingActions.ToggleSelectBatchResult',
  SelectDeselectAllResults: 'BatchUpdateListingActions.SelectDeselectAllResults',
  SetBatchPdfGenerated: 'BatchUpdateListingActions.SetBatchPdfGenerated'
};

export const BatchUpdateListingMutations = {
  RetrieveBatchUpdateSuccess: 'BatchUpdateListingMutations.RetrieveBatchUpdateResultList',
  SetBatchActionParams: 'BatchUpdateListingMutations.SetBatchActionParams',
  SetBatchUpdateTolObject: 'BatchUpdateListingMutations.SetBatchUpdateTolObject',
  SetBatchUpdateResultObjects: 'BatchUpdateListingMutations.SetBatchUpdateResultObjects',
  UpdateSelectedBatchResults: 'BatchUpdateListingMutations.UpdateSelectedBatchResults',
  SelectDeselectResults: 'BatchUpdateListingMutations.SelectDeselectResults',
  SetBatchPdfGenerated: 'BatchUpdateListingMutations.SetBatchPdfGenerated'
};
